/**
 * Sourced from:
 * https://github.com/polleverywhere/random_username/tree/master/lib/random_username
 *
 * This module contains a defined list of English words that may be used by
 * utility functions that need to generate a random phrase, noun or name.
 * No lists are exported by default. Consumers must therefore explicitly define
 * which word lists they need.
 */

/**
 * List of adjectives.
 * @type {string[]}
 */
const adjectives = [
  'able',
  'action',
  'active',
  'actual',
  'adept',
  'adored',
  'adroit',
  'affectionate',
  'agile',
  'airy',
  'alert',
  'alive',
  'alter',
  'amiable',
  'ample',
  'and',
  'anima',
  'apt',
  'ardent',
  'are',
  'astute',
  'august',
  'avid',
  'awake',
  'aware',
  'balmy',
  'benevolent',
  'big',
  'billowing',
  'blessed',
  'bold',
  'boss',
  'brainy',
  'brave',
  'brawny',
  'breezy',
  'brief',
  'bright',
  'brisk',
  'busy',
  'calm',
  'can',
  'canny',
  'cared',
  'caring',
  'casual',
  'celestial',
  'charming',
  'chic',
  'chief',
  'choice',
  'chosen',
  'chummy',
  'civic',
  'civil',
  'classy',
  'clean',
  'clear',
  'clever',
  'close',
  'cogent',
  'composed',
  'cool',
  'cosmic',
  'cozy',
  'cuddly',
  'cute',
  'dainty',
  'dandy',
  'dapper',
  'daring',
  'dear',
  'decent',
  'deep',
  'deft',
  'deluxe',
  'devout',
  'direct',
  'divine',
  'doted',
  'doting',
  'dreamy',
  'driven',
  'dry',
  'earthy',
  'easy',
  'elated',
  'energized',
  'enigmatic',
  'equal',
  'exact',
  'exotic',
  'expert',
  'exuberant',
  'fair',
  'famed',
  'famous',
  'fancy',
  'fast',
  'fiery',
  'fine',
  'fit',
  'flashy',
  'fleek',
  'fleet',
  'flowing',
  'fluent',
  'fluffy',
  'fluttering',
  'flying',
  'fond',
  'frank',
  'free',
  'fresh',
  'full',
  'fun',
  'funny',
  'fuscia',
  'genial',
  'gentle',
  'giddy',
  'gifted',
  'giving',
  'glad',
  'gnarly',
  'gold',
  'golden',
  'good',
  'goodly',
  'graceful',
  'grand',
  'great',
  'green',
  'groovy',
  'guided',
  'gutsy',
  'haloed',
  'happy',
  'hardy',
  'harmonious',
  'hearty',
  'heroic',
  'high',
  'hip',
  'hollow',
  'holy',
  'honest',
  'huge',
  'humane',
  'humble',
  'hunky',
  'icy',
  'ideal',
  'immune',
  'indigo',
  'inquisitive',
  'jazzed',
  'jazzy',
  'jolly',
  'jovial',
  'joyful',
  'joyous',
  'jubilant',
  'juicy',
  'just',
  'keen',
  'khaki',
  'kind',
  'kingly',
  'large',
  'lavish',
  'lawful',
  'left',
  'legal',
  'legit',
  'light',
  'like',
  'liked',
  'likely',
  'limber',
  'limitless',
  'lively',
  'loved',
  'lovely',
  'loyal',
  'lucid',
  'lucky',
  'lush',
  'main',
  'major',
  'master',
  'mature',
  'max',
  'maxed',
  'mellow',
  'merciful',
  'merry',
  'mighty',
  'mint',
  'mirthful',
  'modern',
  'modest',
  'money',
  'moonlit',
  'moral',
  'moving',
  'mucho',
  'mutual',
  'mysterious',
  'native',
  'natural',
  'near',
  'neat',
  'needed',
  'new',
  'nice',
  'nifty',
  'nimble',
  'noble',
  'normal',
  'noted',
  'novel',
  'okay',
  'open',
  'outrageous',
  'overt',
  'pacific',
  'parched',
  'peachy',
  'peppy',
  'pithy',
  'placid',
  'pleasant',
  'plucky',
  'plum',
  'poetic',
  'poised',
  'polite',
  'posh',
  'potent',
  'pretty',
  'prime',
  'primo',
  'prized',
  'pro',
  'prompt',
  'proper',
  'proud',
  'pumped',
  'punchy',
  'pure',
  'purring',
  'quaint',
  'quick',
  'quiet',
  'rad',
  'radioactive',
  'rapid',
  'rare',
  'ready',
  'real',
  'regal',
  'resilient',
  'rich',
  'right',
  'robust',
  'rooted',
  'rosy',
  'rugged',
  'safe',
  'sassy',
  'saucy',
  'savvy',
  'scenic',
  'secret',
  'seemly',
  'serene',
  'sharp',
  'showy',
  'shrewd',
  'simple',
  'sleek',
  'slick',
  'smart',
  'smiley',
  'smooth',
  'snappy',
  'snazzy',
  'snowy',
  'snugly',
  'social',
  'sole',
  'solitary',
  'sound',
  'spacial',
  'spicy',
  'spiffy',
  'spry',
  'stable',
  'star',
  'stark',
  'steady',
  'stoic',
  'strong',
  'stunning',
  'sturdy',
  'suave',
  'subtle',
  'sunny',
  'sunset',
  'super',
  'superb',
  'sure',
  'swank',
  'sweet',
  'swell',
  'swift',
  'talented',
  'teal',
  'the',
  'thriving',
  'tidy',
  'timely',
  'top',
  'tops',
  'tough',
  'touted',
  'tranquil',
  'trim',
  'tropical',
  'true',
  'trusty',
  'undisturbed',
  'unique',
  'united',
  'unsightly',
  'unwavering',
  'upbeat',
  'uplifting',
  'urbane',
  'usable',
  'useful',
  'utmost',
  'valid',
  'vast',
  'vestal',
  'viable',
  'vital',
  'vivid',
  'vocal',
  'vogue',
  'voiceless',
  'volant',
  'wandering',
  'wanted',
  'warm',
  'wealthy',
  'whispering',
  'whole',
  'winged',
  'wired',
  'wise',
  'witty',
  'wooden',
  'worthy',
  'zealous'
]

/**
 * List of nouns.
 * @type {string[]}
 */
const nouns = [
  'abyss',
  'animal',
  'apple',
  'atoll',
  'aurora',
  'autumn',
  'bacon',
  'badlands',
  'ball',
  'banana',
  'bath',
  'beach',
  'bear',
  'bed',
  'bee',
  'bike',
  'bird',
  'boat',
  'book',
  'bowl',
  'branch',
  'bread',
  'breeze',
  'briars',
  'brook',
  'brush',
  'bunny',
  'candy',
  'canopy',
  'canyon',
  'car',
  'cat',
  'cave',
  'cavern',
  'cereal',
  'chair',
  'chasm',
  'chip',
  'cliff',
  'coal',
  'coast',
  'cookie',
  'cove',
  'cow',
  'crater',
  'creek',
  'darkness',
  'dawn',
  'desert',
  'dew',
  'dog',
  'door',
  'dove',
  'drylands',
  'duck',
  'dusk',
  'earth',
  'fall',
  'farm',
  'fern',
  'field',
  'firefly',
  'fish',
  'fjord',
  'flood',
  'flower',
  'flowers',
  'fog',
  'foliage',
  'forest',
  'freeze',
  'frog',
  'fu',
  'galaxy',
  'garden',
  'geyser',
  'gift',
  'glass',
  'grove',
  'guide',
  'guru',
  'hat',
  'hug',
  'hero',
  'hill',
  'horse',
  'house',
  'hurricane',
  'ice',
  'iceberg',
  'island',
  'juice',
  'lagoon',
  'lake',
  'land',
  'lawn',
  'leaf',
  'leaves',
  'light',
  'lion',
  'marsh',
  'meadow',
  'milk',
  'mist',
  'moon',
  'moss',
  'mountain',
  'mouse',
  'nature',
  'oasis',
  'ocean',
  'pants',
  'peak',
  'pebble',
  'pine',
  'pilot',
  'plane',
  'planet',
  'plant',
  'plateau',
  'pond',
  'prize',
  'rabbit',
  'rain',
  'range',
  'reef',
  'reserve',
  'resonance',
  'river',
  'rock',
  'sage',
  'salute',
  'sanctuary',
  'sand',
  'sands',
  'shark',
  'shelter',
  'shirt',
  'shoe',
  'silence',
  'sky',
  'smokescreen',
  'snowflake',
  'socks',
  'soil',
  'soul',
  'soup',
  'sparrow',
  'spoon',
  'spring',
  'star',
  'stone',
  'storm',
  'stream',
  'summer',
  'summit',
  'sun',
  'sunrise',
  'sunset',
  'sunshine',
  'surf',
  'swamp',
  'table',
  'teacher',
  'temple',
  'thorns',
  'tiger',
  'tigers',
  'towel',
  'train',
  'tree',
  'truck',
  'tsunami',
  'tundra',
  'valley',
  'volcano',
  'water',
  'waterfall',
  'waves',
  'wild',
  'willow',
  'window',
  'winds',
  'winter',
  'zebra'
]

/**
 * Add additional export symbols as needed. Defining them here makes it easier
 * to see what this module exports.
 */
export {
  adjectives,
  nouns
}
